import { createAction, props } from '@ngrx/store';

export const saveContent = createAction('[RapidQL] Save Content', props<{ filters: any }>());
